import controller from './grouped.controller';
import template from './grouped.html';

export default {
    controller,
    template,
    bindings: {
        xlabel: '<',
        ylabel: '<',
        xlabels: '<',
        data: '<',
        title: '<',
        height: '<',
        excludedItems: '<',
        onLegendItemToggle: '<'
    }
};



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/graphs/grouped/grouped.component.js